import { BinaryMessage, HTTPContentType } from '../common/index.js';
export async function postRequest(url, header, body, isBinary) {
    const request = {
        header: { ...header, ...{ id: 0, type: header.type } },
        body: body
    };
    const rawResponse = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': isBinary ? HTTPContentType.Binary : HTTPContentType.JSON,
        },
        body: isBinary ? BinaryMessage.encode(request) : JSON.stringify(request)
    });
    if (!rawResponse.ok) {
        const text = await rawResponse.text();
        console.error(`fetch result error: ${text}`);
        throw new Error(text);
    }
    if (rawResponse.status === 204) {
        return null;
    }
    const contentType = rawResponse.headers.get('Content-Type') || '';
    let parsedReqponse = null;
    if (contentType.includes(HTTPContentType.JSON)) {
        parsedReqponse = await rawResponse.json();
    }
    else if (contentType.includes(HTTPContentType.Binary)) {
        const buffer = await rawResponse.arrayBuffer();
        parsedReqponse = BinaryMessage.decode(new Uint8Array(buffer));
    }
    else {
        throw new Error(`fetch result: unsupported Content-Type [${contentType}]`);
    }
    return parsedReqponse;
}
//# sourceMappingURL=PostRequest.js.map